import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import DateUtils from "Utils/DateUtils";
import SearchInputByKeyword from "Components/common/SearchInputByKeyword";
import FilterByDateTab from "Components/common/FilterByDateTab";
import ConnectedInboxLoader from "./ConnectedInboxLoader";
import ConnectedInboxList from "./ConnectedInboxList";
import connectedInboxStore from "./store";
import FilterByWarming from "./FilterByWarming";
import { USER_SELECT_DROPDOWN_LIST as userObjList } from "Static/constant";
import UserDropdown from "Components/common/UserDropdown";
import Utils from "Utils/utils";
import userDetail from "Stores/userDetail";
import CheckBox from "Components/common/CheckBox";
import BulkEditInboxFieldsPopup from "./BulkEditInboxFieldsPopup";

const ConnectedInbox = observer((props = {}) => {
  const {
    team = false,
    hasTeamMember = false,
    isTeamOwner = false,
    memberId = ""
  } = userDetail?.userInfo || {};
  const { noOfContactsAddedInTeam } = userDetail?.userFeatureFlag || {};
  const [teamList, setTeamList] = useState("");
  const [teamLoader, setTeamLoader] = useState(true);
  const [userFilterList, setUserFilterList] = useState(userObjList);

  const handleSearchByKeyword = (searchEmail = "") => {
    connectedInboxStore.setFilterChanged(true);
    connectedInboxStore.setSearchTerm(searchEmail);
    connectedInboxStore.setPageNo(1);
    connectedInboxStore.setPageLimit(10);
    connectedInboxStore.getAccountDetails(
      false,
      connectedInboxStore.filterChanged
    );
  };

  const getFilterByDate = (value = {}) => {
    const { filterFromDate = "", filterToDate = "" } = value || {};
    let fromDate = DateUtils.getTimeStamp(filterFromDate, "start") || "";
    let toDate = DateUtils.getTimeStamp(filterToDate, "end") || "";
    let dateFilter = { fromDate, toDate };
    connectedInboxStore.setFilterChanged(true);
    connectedInboxStore.setDateFilter(dateFilter);
  };

  const setActiveDateFilter = (value = "") =>
    connectedInboxStore.setActiveDateTab(
      value?.toLowerCase() === "alltask" ? "today" : value
    );

  const resetUserFilterOption = () => {
    const newArr = [...userFilterList];
    newArr.map(item => (item.checked = item?.id?.toLowerCase() === "all"));
    setUserFilterList(newArr);
  };

  const getTeamList = async () => {
    const resData = await Utils.userTeamList();
    userDetail.setUserInfo({
      ...userDetail?.userInfo,
      hasTeamMember: resData?.length ? resData : false
    });
    setTeamList(resData);
    setTeamLoader(false);
  };

  const getSelectedUserPayload = data => {
    return typeof data === "object"
      ? data?.length && data
      : data?.length && data?.toLowerCase() === "you"
        ? new Array(memberId)
        : "";
  };

  const makeFilterRequest = (user = {}) => {
    const payload = {};
    const selectedIds = getSelectedUserPayload(user);
    connectedInboxStore.setFilterChanged(true);
    if (Object?.keys(user)?.length) {
      if (!team) {
        payload.memberIds = [memberId];
      } else if (selectedIds?.length) {
        payload.memberIds = selectedIds;
      }
    }
    return payload;
  };

  const selectedUserCbk = (value = "") => {
    if (value) {
      let payload = makeFilterRequest(value);
      connectedInboxStore.setMembersFilter(payload || {});
    }
  };

  useEffect(() => {
    getTeamList();
    return () => {
      resetUserFilterOption();
    };
  }, []);

  return (
    <>
      {(connectedInboxStore?.isInboxConnected ||
        connectedInboxStore?.loading) &&
        !connectedInboxStore?.showSmtpViaWarming && (
          <>
          <div className="connectedInboxHeader">
            <SearchInputByKeyword
              id="searchInbox"
              placeholder="Search Inbox"
              handleSearch={handleSearchByKeyword}
            />
            {Utils.isAdmin() && (
              <div className="filterInbox">
                <UserDropdown
                  team={team}
                  teamList={teamList}
                  teamLoader={teamLoader}
                  selectedUserCbk={selectedUserCbk}
                  isContactsAdded={noOfContactsAddedInTeam > 0}
                  userFilterList={Utils.filterByUserTeamFilterList(userObjList)}
                />
              </div>
            )}
            <div
              className={`${Utils.isAdmin()
                ? "connectedInboxWrapperIsAdmin"
                : "connectedInboxWrapper"
                }`}
            >
              <FilterByDateTab
                activeDueTab={connectedInboxStore?.activeDateTab}
                setActiveDueTab={setActiveDateFilter}
                cbk={getFilterByDate}
                isTaskPage={false}
                pageType="connectedInbox"
              />
              <FilterByWarming />
            </div>
          </div>
          <div className="bulkEditInboxBar">
            <div className="bulkSelectAll">
              <CheckBox
                checked={
                  connectedInboxStore.accountData.length > 0 &&
                  connectedInboxStore.accountData.every(i =>
                    connectedInboxStore.selectedInboxIds.includes(i.id)
                  )
                }
                indeterminate={
                  connectedInboxStore.accountData.some(i =>
                    connectedInboxStore.selectedInboxIds.includes(i.id)
                  ) &&
                  !connectedInboxStore.accountData.every(i =>
                    connectedInboxStore.selectedInboxIds.includes(i.id)
                  )
                }
                cbk={checked => {
                  if (checked) {
                    connectedInboxStore.setSelectedInboxIds(
                      connectedInboxStore.accountData.map(i => i.id)
                    );
                  } else {
                    connectedInboxStore.clearSelection();
                  }
                }}
              />
              <span className="selectAllLabel">Select all</span>
            </div>
            <div className="bulkEditActions">
              {connectedInboxStore.selectedInboxIds.length > 0 && (
                <span className="selectedCount">
                  <span className="selectedCountNum">
                    {connectedInboxStore.selectedInboxIds.length}
                  </span>{" "}
                  selected
                </span>
              )}
              <button
                className={`bulkEditFieldsBtn ${
                  connectedInboxStore.selectedInboxIds.length > 0
                    ? "enabled"
                    : "disabled"
                }`}
                onClick={() => {
                  if (connectedInboxStore.selectedInboxIds.length > 0) {
                    connectedInboxStore.setBulkEditPopupOpen(true);
                  }
                }}
                disabled={connectedInboxStore.selectedInboxIds.length === 0}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Edit Fields
              </button>
            </div>
          </div>
          </>
        )}
      {connectedInboxStore?.loading ? (
        <ConnectedInboxLoader count={7} />
      ) : (
        connectedInboxStore?.isInboxConnected && (
          <ConnectedInboxList {...props} />
        )
      )}
      {connectedInboxStore.bulkEditPopupOpen && <BulkEditInboxFieldsPopup />}
    </>
  );
});

export { ConnectedInbox, ConnectedInboxLoader };
export default ConnectedInbox;
